import { Injectable } from '@angular/core';
import * as dayjs from 'dayjs';
import { GlobalConstants } from '../constant/constant';
import { StoreName } from '../entities/StoreName';
import { SyncTable } from '../entities/SyncStatus';
import * as updateLocale from 'dayjs/plugin/updateLocale';
dayjs.extend(updateLocale);
const localeObject = {
  name: 'se-time',
  weekStart: GlobalConstants.START_OF_WEEK, // sets Saturday as start of week
};
dayjs.updateLocale('en', localeObject);
@Injectable({
  providedIn: 'root',
})
export class SyncMasterService {
  private SyncTables: SyncTable[] = [
    {
      Id: 1,
      tableName: StoreName.TimeRecord,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 2,
      tableName: StoreName.Project,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 3,
      tableName: StoreName.Task,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 4,
      tableName: StoreName.LaborCategory,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 5,
      tableName: StoreName.FIPSState,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 6,
      tableName: StoreName.User,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 7,
      tableName: StoreName.Activity,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 8,
      tableName: StoreName.ActivityLog,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 9,
      tableName: StoreName.Users2FieldActivity,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 11,
      tableName: StoreName.CurrentWorkAssignment,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
    },
    {
      Id: 12,
      tableName: StoreName.Photo,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 13,
      tableName: StoreName.IncidentType,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 14,
      tableName: StoreName.IncidentCategory,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 15,
      tableName: StoreName.Incident,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 16,
      tableName: StoreName.Message,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 17,
      tableName: StoreName.BusinessRule,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 18,
      tableName: StoreName.BusinessActivityLog,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 19,
      tableName: StoreName.EventLog,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
    },
    {
      Id: 20,
      tableName: StoreName.EntityType,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 21,
      tableName: StoreName.StatusLookup,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 22,
      tableName: StoreName.Attachment,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 23,
      tableName: StoreName.TimeRecordStatus,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 24,
      tableName: StoreName.TimeManager2Project,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 25,
      tableName: StoreName.TeamUsers,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 26,
      tableName: StoreName.Team2User,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 27,
      tableName: StoreName.Team,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 28,
      tableName: StoreName.Users2Project,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 29,
      tableName: StoreName.FormDefinition,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'id',
    },
    {
      Id: 30,
      tableName: StoreName.FormDocuments,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'DocumentId',
    },
    {
      Id: 31,
      tableName: StoreName.ChoiceDefinition,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'id',
    },
    {
      Id: 32,
      tableName: StoreName.DeviceIdAndDocumentIdSequence,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
    },
    {
      Id: 33,
      tableName: StoreName.NotableActivityOption,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    },
    {
      Id: 34,
      tableName: StoreName.FieldActivity,
      primaryKeyPath: GlobalConstants.DEFAULT_PRIMARY_KEY,
      idIndexKeyPath: 'Id',
    }
  ];

  getSyncMasterTables(): SyncTable[] {
    return [...this.SyncTables];
  }

  getIdIndexKeyPath(tableName: string): string {
    const table = this.SyncTables.find(table => table.tableName.toLowerCase() === tableName.toLowerCase());

    if (!table) {
      throw new Error(`Table not found: ${tableName}`);
    }
    if (!table.idIndexKeyPath) {
      throw new Error(`idIndexKeyPath not found for table: ${tableName}`);
    }

    return table.idIndexKeyPath;
  }
}
